import React from 'react';

const FormSection = React.createClass({
	render(){
		return (
			<div className="ma-form-section">
				{this.props.children}
			</div>
		);
	}
});
export default FormSection;


/** WEBPACK FOOTER **
 ** ./src/components/FormSection/FormSection.js
 **/